/* eslint-disable no-self-compare */
/* eslint-disable no-useless-concat */
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const WLTableOneTBody = ({
  styles,
  myFav,
  order,
  orderBy,
  checkDate,
  deleteCheck,
  setChekboxes,
  classes,
  makeModalRowDataRRModal,
  makeModalRowData,
}) => {
  return (
    <TableBody style={styles.tableBody}>
      {myFav &&
        myFav
          .sort((a, b) => {
            if (
              !orderBy ||
              (!(
                typeof a[orderBy] === 'number' || typeof a[orderBy] === 'string'
              ) &&
                typeof a[orderBy] === typeof a[orderBy])
            )
              return 0;

            if (typeof a[orderBy] === 'number')
              return order === 'desc'
                ? a[orderBy] - b[orderBy]
                : b[orderBy] - a[orderBy];
            else {
              return order === 'desc'
                ? a[orderBy].localeCompare(b[orderBy])
                : b[orderBy].localeCompare(a[orderBy]);
            }
          })
          .map((row, index) => {
            let check = moment(checkDate, 'YYYY-MM-DD').isAfter(row.Expiry);
            return (
              <TableRow
                style={{
                  ...styles.tableRow,
                  background: index % 2 ? '#e5e5e5' : 'white',
                }}
                key={index}
              >
                {deleteCheck && (
                  <TableCell style={{ ...styles.modalTableRow }} align="center">
                    <Checkbox
                      checked={row.value}
                      onClick={() => setChekboxes(row, index)}
                      classes={{ root: classes.root }}
                    />
                  </TableCell>
                )}
                <TableCell style={{ ...styles.modalTableRow }} align="center">
                  {moment(row.date).format('DD-MMM-YY')}
                </TableCell>

                <TableCell style={{ ...styles.modalTableRow }} align="center">
                  ${parseFloat(row.Stock).toFixed(2)}
                </TableCell>
                <TableCell style={{ ...styles.modalTableRow }} align="center">
                  {row.symbol}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    backgroundColor: check ? 'rgb(193, 2, 0)' : '',
                    color: check ? 'white' : 'black',
                    fontWeight: check ? 'bold' : '',
                  }}
                  align="center"
                >
                  {moment(row.Expiry).format('DD-MMM-YY')}
                </TableCell>
                <TableCell
                  style={{ ...styles.modalTableRow, textAlign: 'end' }}
                  align="center"
                >
                  {parseFloat(row.Strike)}
                </TableCell>

                <TableCell
                  style={{ ...styles.modalTableRow, textAlign: 'end' }}
                  align="center"
                >
                  {row.PutCall}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    padding: '0 5px',
                    textAlign: 'end',
                  }}
                  align="center"
                >
                  ${row.Price.toFixed(2)}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    padding: '0 5px',
                    backgroundColor: 'rgba(255, 252, 209,0.5)',
                    textAlign: 'end',
                    cursor: 'pointer',
                  }}
                  align="right"
                  className="toggleCells"
                  onClick={() => makeModalRowDataRRModal(row)}
                >
                  {row.RR ? '$' + row.RR.toFixed(2) : '-'}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    width: '60px',
                    borderLeft: '1px solid',
                  }}
                  align="center"
                >
                  {!row.secondstock
                    ? '-'
                    : row.secondstock === '-'
                    ? '-'
                    : `$` + row.secondstock}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    color: row.chgDollar >= 0 ? 'green' : 'red',
                  }}
                  align="center"
                >
                  {!row.chgDollar
                    ? '-'
                    : row.chgDollar === '-'
                    ? '-'
                    : row.chgDollar < 0
                    ? `-` + `$` + Math.abs(row.chgDollar).toFixed(2)
                    : `$` + row.chgDollar.toFixed(2)}
                </TableCell>
                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    color: row.chgPercent >= 0 ? 'green' : 'red',
                  }}
                  align="center"
                >
                  {!row.chgPercent
                    ? '-'
                    : row.chgPercent === '-'
                    ? '-'
                    : (row.chgPercent).toFixed(2) + `%`}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    backgroundColor: 'rgba(127, 211, 210, 0.5 )',
                    cursor: 'pointer',
                  }}
                  align="center"
                  className="toggleCells"
                  onClick={async () => {
                    makeModalRowData(row);
                  }}
                >
                  {!row.option
                    ? '-'
                    : row.option === '-'
                    ? row.option
                    : '$' + row.option}
                </TableCell>
                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    color: row.optionchgDollar >= 0 ? 'green' : 'red',
                  }}
                  align="center"
                >
                  {row.optionchgDollar === '-'
                    ? row.optionchgDollar
                    : row.optionchgDollar < 0
                    ? `-` + `$` + Math.abs(row.optionchgDollar).toFixed(2)
                    : `$` + row.optionchgDollar.toFixed(2)}
                </TableCell>

                <TableCell
                  style={{
                    ...styles.modalTableRow,
                    textAlign: 'end',
                    color: row.optionchgPercent >= 0 ? 'green' : 'red',
                  }}
                  align="right"
                >
                  {row.optionchgPercent === '-'
                    ? row.optionchgPercent
                    : (row.optionchgPercent * 100).toFixed(2) + '%'}
                </TableCell>
              </TableRow>
            );
          })}
    </TableBody>
  );
};
export default WLTableOneTBody;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/components/tableOneComponents/WLTableOneTBody.jsx